import React, { useEffect, useState } from 'react'
import './countdown.css'
import pictureOne from './1.jpg'
import pictureTwo from './2.jpg'
import pictureThree from './3.jpg'
import pictureFour from './4.jpg'
import pictureFive from './5.jpg'
import pictureSix from './6.jpg'
import pictureSeven from './7.jpg'
import pictureEight from './8.jpg'
import pictureNine from './9.jpg'
import pictureTen from './10.jpg'
import pictureEleven from './11.jpg'
import pictureElevenFive from './11_5.jpg'
import pictureTwelve from './12.jpg'
import pictureThirteen from './13.jpg'
import pictureFourteen from './14.jpg'
import pictureFifteen from './15.jpg'
import pictureSixteen from './16.jpg'
import pictureSeventeen from './17.jpg'
import pictureEighteen from './18.jpg'
import CountdownEntry from './CountdownEntry'
import { use } from 'react'

export default function Countdown() {
  const [timeLeft, setTimeLeft] = useState('')
  const [pictureDescription, setPictureDescription] = useState('')
  const [colorDescription, setColorDescription] = useState('')
  const [imageSource, setImageSource] = useState()
  const [upperTimerText, setUpperTimeText] = useState('Just a quick')
  const [lowerTimerText, setLowerTimerText] = useState('till we live together')
  const [entriesList, setEntriesList] = useState([])
    const targetDate = new Date('2026-02-15T19:57:00-06:00')

  useEffect(() => {

    const updateCountdown = () => {
      const now = new Date()
      let difference = targetDate - now

      // Determine direction (before or after)
      const isPast = difference < 0

      if(isPast){
        setUpperTimeText('It has been')
        setLowerTimerText('of living together')
      }

      // Always work with absolute value
      difference = Math.abs(difference)

      var days = Math.floor(difference / (1000 * 60 * 60 * 24))
      var hours = Math.floor((difference / (1000 * 60 * 60)) % 24)
      const minutes = Math.floor((difference / (1000 * 60)) % 60)
      const seconds = Math.floor((difference / 1000) % 60)

      setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`)
      
    }

    updateCountdown()
    const interval = setInterval(updateCountdown, 1000)

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    const now = new Date()
    let difference = targetDate - now
    const isPast = difference < 0

    // ADD UPDATE TO MAKE THIS A LIST OF ALL OF THEM. MAYBE ON LAST
      const countdownContainerElement = document.getElementById('countdown-container')
      const countdownDashedLinesBottomElement = document.getElementById('countdown-dashed-line-bottom')
      const countdownDashedLinesTopElement = document.getElementById('countdown-dashed-line-top')

      var entriesListLocal = []
      // days = 18
        let picDescriptionParam = 'Hotel Acrobatics. Jumps, flips, rolls, galore, and more.'
        let colorDescriptionParam = 'Red. Inspired by the red object in the building across the street during our Eye Spy game.'
        let backgroundColor = '#a51919'
        let textColor = 'white'
        let specialEffect = 'countdown-background-effect-dots'
        let borderTop = '2px dashed black'
        entriesListLocal.unshift(<CountdownEntry 
          pictureDescriptionParam={picDescriptionParam} 
          imageSourceParam={pictureOne} 
          colorDescriptionParam={colorDescriptionParam} 
          backgroundColor={backgroundColor} 
          textColor={textColor} 
          borderTop={borderTop} 
          specialEffect={specialEffect} 
          index={16}
        />)


        picDescriptionParam = 'You got da typa brain that easily solves puzzles it\'s big as hell fr'
        colorDescriptionParam = 'Cardboard Brown. Inspired by the cardboard box that housed our puzzle through 300 miles of road trip.'
        backgroundColor = '#BB8E51'
        textColor = 'white'
        specialEffect = 'countdown-background-effect-dots'
        borderTop = '2px dashed black'
        entriesListLocal.unshift(<CountdownEntry 
          pictureDescriptionParam={picDescriptionParam} 
          imageSourceParam={pictureTwo} 
          colorDescriptionParam={colorDescriptionParam} 
          backgroundColor={backgroundColor} 
          textColor={textColor} 
          borderTop={borderTop} 
          specialEffect={specialEffect} 
          index={15}
        />)



        picDescriptionParam = 'Looking through our photos, I believe this to be the one that exudes the most swag.'
        colorDescriptionParam = 'Electric Purple. When I think of swag, I think of purple. Reminds me of LMFAO... what a time.'
        backgroundColor = ''
        textColor = 'white'
        specialEffect = 'countdown-background-effect-swag'
        borderTop = '2px dashed white'
        //ment.getElementById('countdown-container').style.backgroundColor = '#8F00FF'
        entriesListLocal.unshift(<CountdownEntry 
          pictureDescriptionParam={picDescriptionParam} 
          imageSourceParam={pictureThree} 
          colorDescriptionParam={colorDescriptionParam} 
          backgroundColor={backgroundColor} 
          textColor={textColor} 
          borderTop={borderTop} 
          specialEffect={specialEffect} 
          index={14}
        />)



        picDescriptionParam = 'A lovely photo, truly. The views are scenic and I appreciate your gorgeous smile. I recall that I was feeling anxious, as I tend to do, and you handled it really well, as you tend to do. I love you.'
        colorDescriptionParam = 'Sunrise Yellow, because of our early wake up and the nice beams on our face.'
        backgroundColor = '#fec108'
        textColor = 'black'
        specialEffect = 'countdown-background-effect-waves-white'
        borderTop = '2px dashed black'
        entriesListLocal.unshift(<CountdownEntry 
          pictureDescriptionParam={picDescriptionParam} 
          imageSourceParam={pictureFour} 
          colorDescriptionParam={colorDescriptionParam} 
          backgroundColor={backgroundColor} 
          textColor={textColor} 
          borderTop={borderTop} 
          specialEffect={specialEffect} 
          index={13}
        />)



        picDescriptionParam = 'The in between of our phone background photos. That packaged oatmeal hit. Also, the whole time I had a slight worry one of us would fall into the pond lol. '
        colorDescriptionParam = 'Mossy Green, because you inspired me to touch the moss. Nice texture.'
        backgroundColor = '#757e3c'
        textColor = 'white'
        specialEffect = 'countdown-background-effect-waves-black'
        borderTop = '2px dashed black'
        entriesListLocal.unshift(<CountdownEntry 
          pictureDescriptionParam={picDescriptionParam} 
          imageSourceParam={pictureFive} 
          colorDescriptionParam={colorDescriptionParam} 
          backgroundColor={backgroundColor} 
          textColor={textColor} 
          borderTop={borderTop} 
          specialEffect={specialEffect} 
          index={12}
        />)



        picDescriptionParam = 'One of the greats... just a weird photo. Weird like us. I like weird.'
        colorDescriptionParam = 'Black background because of your dress, white dots because of my shoes.'
        backgroundColor = '#1a1a1aff'
        textColor = 'white'
        specialEffect = 'countdown-background-effect-double-dots-white'
        borderTop = '2px dashed black'
        entriesListLocal.unshift(<CountdownEntry 
          pictureDescriptionParam={picDescriptionParam} 
          imageSourceParam={pictureSix} 
          colorDescriptionParam={colorDescriptionParam} 
          backgroundColor={backgroundColor} 
          textColor={textColor} 
          borderTop={borderTop} 
          specialEffect={specialEffect} 
          index={11}
        />)



        picDescriptionParam = 'CHOMP CHOMP.'
        colorDescriptionParam = 'Pink. Inspired by the wedding and love.'
        backgroundColor = '#F7B3CD'
        textColor = 'white'
        specialEffect = 'countdown-background-effect-squares'
        borderTop = '2px dashed black'
        entriesListLocal.unshift(<CountdownEntry 
          pictureDescriptionParam={picDescriptionParam} 
          imageSourceParam={pictureSeven} 
          colorDescriptionParam={colorDescriptionParam} 
          backgroundColor={backgroundColor} 
          textColor={textColor} 
          borderTop={borderTop} 
          specialEffect={specialEffect} 
          index={10}
        />)



        picDescriptionParam = 'Cute ass photo! Elite tier. Also, what a great time this was!!!'
        colorDescriptionParam = 'Muddy Brown. Inspired by my SLIP.'
        backgroundColor = '#563719'
        textColor = 'white'
        specialEffect = 'countdown-background-effect-dots'
        borderTop = '2px dashed black'
        entriesListLocal.unshift(<CountdownEntry 
          pictureDescriptionParam={picDescriptionParam} 
          imageSourceParam={pictureEight} 
          colorDescriptionParam={colorDescriptionParam} 
          backgroundColor={backgroundColor} 
          textColor={textColor} 
          borderTop={borderTop} 
          specialEffect={specialEffect} 
          index={9}
        />)



        picDescriptionParam = 'Right on my lap where I like you. I never knew that this was a possible way to drive, I hope we do it again soon. I appreciate how you find fun ways to bring us closer my love.'
        colorDescriptionParam = 'Brake Light Red. Riding through the north cascades, with you in my lap singing songs, where the occasional brake light would glow ahead.'
        backgroundColor = '#ee0000ff'
        textColor = 'white'
        specialEffect = 'countdown-background-effect-colored-tiles-red'
        borderTop = '2px dashed white'
        entriesListLocal.unshift(<CountdownEntry 
          pictureDescriptionParam={picDescriptionParam} 
          imageSourceParam={pictureNine} 
          colorDescriptionParam={colorDescriptionParam} 
          backgroundColor={backgroundColor} 
          textColor={textColor} 
          borderTop={borderTop} 
          specialEffect={specialEffect} 
          index={8}
        />)



        picDescriptionParam = 'Smooch. I look forward to future back packing trips, I would love to do multiple nights at some point. I like your hair a lot in this photo, and your face as well, and your lips too!'
        colorDescriptionParam = 'Night Sky. Thank you for getting us outside to look at the stars.'
        backgroundColor = '#1b1b1bff'
        textColor = 'white'
        specialEffect = 'countdown-background-effect-stars'
        borderTop = '2px dashed white'
        entriesListLocal.unshift(<CountdownEntry 
          pictureDescriptionParam={picDescriptionParam} 
          imageSourceParam={pictureTen} 
          colorDescriptionParam={colorDescriptionParam} 
          backgroundColor={backgroundColor} 
          textColor={textColor} 
          borderTop={borderTop} 
          specialEffect={specialEffect} 
          index={7}
        />)



        picDescriptionParam = 'im da baby'
        colorDescriptionParam = 'Shit Brown. Inspired by the shit in my diaper.'
        backgroundColor = '#4d2601ff'
        textColor = 'white'
        specialEffect = 'countdown-background-effect-shit'
        borderTop = '2px dashed white'
        entriesListLocal.unshift(<CountdownEntry 
          pictureDescriptionParam={picDescriptionParam} 
          imageSourceParam={pictureEleven} 
          colorDescriptionParam={colorDescriptionParam} 
          backgroundColor={backgroundColor} 
          textColor={textColor} 
          borderTop={borderTop} 
          specialEffect={specialEffect} 
          index={6}
        />)



        picDescriptionParam = 'Another elite tier photo. All the photos we take inside a car are just really good somehow.'
        colorDescriptionParam = 'Electrocardiogram. Not really a color, but it does show that my heart beat big.'
        backgroundColor = '#fffde5ff'
        textColor = 'black'
        specialEffect = 'countdown-background-effect-heart-rhythm'
        borderTop = '2px dashed black'
        entriesListLocal.unshift(<CountdownEntry 
          pictureDescriptionParam={picDescriptionParam} 
          imageSourceParam={pictureTwelve} 
          colorDescriptionParam={colorDescriptionParam} 
          backgroundColor={backgroundColor} 
          textColor={textColor} 
          borderTop={borderTop} 
          specialEffect={specialEffect} 
          index={5}
        />)



        picDescriptionParam = '🤙 shaka to repel the seattle kids'
        colorDescriptionParam = 'Grey, because of the smokey haze. I like the way it layers the mountains in this photo.'
        backgroundColor = '#e7e7e7ff'
        textColor = 'black'
        specialEffect = 'countdown-background-effect-mountains'
        borderTop = '2px dashed black'
        entriesListLocal.unshift(<CountdownEntry 
          pictureDescriptionParam={picDescriptionParam} 
          imageSourceParam={pictureThirteen} 
          colorDescriptionParam={colorDescriptionParam} 
          backgroundColor={backgroundColor} 
          textColor={textColor} 
          borderTop={borderTop} 
          specialEffect={specialEffect} 
          index={4}
        />)


      
        picDescriptionParam = 'Twins. Matching shirts, crocs, heads, hearts, and spirits.'
        colorDescriptionParam = 'Teal and White. Just like our shirts.'
        backgroundColor = '#73b8a5ff'
        textColor = 'white'
        specialEffect = 'countdown-background-effect-waves-white'
        borderTop = '2px dashed white'
        entriesListLocal.unshift(<CountdownEntry 
          pictureDescriptionParam={picDescriptionParam} 
          imageSourceParam={pictureFourteen} 
          colorDescriptionParam={colorDescriptionParam} 
          backgroundColor={backgroundColor} 
          textColor={textColor} 
          borderTop={borderTop} 
          specialEffect={specialEffect} 
          index={3}
        />)



        picDescriptionParam = 'My favorite photo. I like how genuine it is. Being silly, laughing, looking at eachother. And you truly look so adorable.'
        colorDescriptionParam = 'Pee Yellow, for all the times we\'ve supported each other in that bathroom.'
        backgroundColor = '#fff5a8ff'
        textColor = 'black'
        specialEffect = 'countdown-background-effect-waves-black'
        borderTop = '2px dashed black'
        entriesListLocal.unshift(<CountdownEntry 
          pictureDescriptionParam={picDescriptionParam} 
          imageSourceParam={pictureFifteen} 
          colorDescriptionParam={colorDescriptionParam} 
          backgroundColor={backgroundColor} 
          textColor={textColor} 
          borderTop={borderTop} 
          specialEffect={specialEffect} 
          index={2}
        />)



        picDescriptionParam = 'Your favorite photo. I enjoyed my time with you in Vancouver very much my love.'
        colorDescriptionParam = 'Grey to Green gradient, representing the clouds rolling over the mountains.'
        backgroundColor = ''
        textColor = 'white'
        specialEffect = 'countdown-background-effect-grey-to-green-gradient'
        borderTop = '2px dashed white'
        entriesListLocal.unshift(<CountdownEntry 
          pictureDescriptionParam={picDescriptionParam} 
          imageSourceParam={pictureSixteen} 
          colorDescriptionParam={colorDescriptionParam} 
          backgroundColor={backgroundColor} 
          textColor={textColor} 
          borderTop={borderTop} 
          specialEffect={specialEffect} 
          index={1}
        />)



        picDescriptionParam = '100% us. Duck Dog now and forever will serve as a reminder that we are who we are, for better and for worse. I love you and I accept every part of you my love.'
        colorDescriptionParam = 'Ajumma Yellow. The same color of the original duck dog shirt.'
        backgroundColor = '#fcff3fff'
        textColor = 'black'
        specialEffect = 'countdown-background-effect-double-dots-blue'
        borderTop = '2px dashed black'
        entriesListLocal.unshift(<CountdownEntry 
          pictureDescriptionParam={picDescriptionParam} 
          imageSourceParam={pictureSeventeen} 
          colorDescriptionParam={colorDescriptionParam} 
          backgroundColor={backgroundColor} 
          textColor={textColor} 
          borderTop={borderTop} 
          specialEffect={specialEffect} 
          index={0}
          isPast={isPast}
        />)

        if(isPast){
          picDescriptionParam = 'Now we live together!'
        colorDescriptionParam = 'Facetime Green. Now we spend Time looking at each others real Face.'
        backgroundColor = '#58ee70'
        textColor = 'black'
        specialEffect = 'countdown-background-effect-waves-black'
        borderTop = '2px dashed black'
        entriesListLocal.unshift(<CountdownEntry 
          pictureDescriptionParam={picDescriptionParam} 
          imageSourceParam={pictureEighteen} 
          colorDescriptionParam={colorDescriptionParam} 
          backgroundColor={backgroundColor} 
          textColor={textColor} 
          borderTop={borderTop} 
          specialEffect={specialEffect} 
          index={100}
          isPast={isPast}
        />)
        }

      setEntriesList(entriesListLocal)
  }, [])

  return (
    <div id="countdown-container-entries-list" className="countdown-container-entries-list">
      <div className="entry-countdown-timer-container">
        <div className='entry-countdown-dashed-line-top-container'>
          <div id='countdown-dashed-line-top' className='entry-countdown-dashed-line-top'></div>
        </div>
        <div className='entry-countdown-timer-top-container'>
          {upperTimerText}
        </div>
        <div className="entry-countdown-timer">{timeLeft}</div>
        <div className='entry-countdown-timer-bottom-container'>
          {lowerTimerText}
        </div>
        <div className='entry-countdown-dashed-line-bottom-container'>
          <div id='countdown-dashed-line-bottom' className='entry-countdown-dashed-line-bottom'></div>
        </div>
      </div>
      {entriesList}
    </div>
  )
}
